export function httpJsonError(status,body){
  let parsed=body;try{if(typeof body==='string')parsed=JSON.parse(body);}catch{parsed=null;}
  const detail=parsed?.error && typeof parsed.error==='object'?parsed.error:parsed;
  const error=new Error(detail?.message || (typeof parsed?.error==='string'?parsed.error:`HTTP ${status}`));
  error.status=status;error.code=detail?.code || detail?.status || parsed?.code;error.details=detail?.details || parsed?.details || null;
  return error;
}
